import { Typography } from '@mui/material'
import moment from 'moment'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useAccount, useMe } from 'src/hooks'
import { useStyles } from './styles'

interface IProps {
  subscriptionEnd: number | null
}

export const SubscriptionEnd = ({ subscriptionEnd }: IProps) => {
  const classes = useStyles()
  const { data: account } = useAccount()
  const { data: user } = useMe()

  if (!subscriptionEnd || !account || !user) return null

  return (
    <Typography className={classes.subscriptionEndText}>
      <HelperWrapper
        t={account.subscription_cancelled ? 'subscription-end-label-1' : 'subscription-end-label-2'}
      />
      &nbsp;
      {moment(subscriptionEnd * 1000)
        .tz(user?.timezone ?? 'UTC')
        .format('LL')}
    </Typography>
  )
}
